// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/bonusprogram-" + chunkId + "." + {"1":"69a310fc","2":"1e504b81","3":"a065964c","4":"aa98bd47","5":"93ebc3f1"}[chunkId] + ".min.js";
};